import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.validate()
  }

  validate () {
    const oneFilled = this.inputTargets.some(el => {
      if (el.type === "checkbox" || el.type === "radio") {
        return el.checked
      } else {
        return el.value.trim() !== ""
      }
    })

    this.inputTargets.forEach((el, index) => {
      el.required = !oneFilled && index === 0
    })
  }
}
